import { IconButton, IconButtonProps, styled } from '@mui/material';
import { SVGProps } from 'react';

import { ReactComponent as Document } from 'assets/icons/document.svg';
import { ReactComponent as Microphone } from 'assets/icons/microphone.svg';

interface MenuButtonProps extends IconButtonProps {
	language: string;
}

interface DocumentIconProps extends SVGProps<SVGSVGElement> {
	choosedfile: boolean;
	isdisabled?: boolean;
}

export const MenuButton = styled(IconButton)<MenuButtonProps>(({ language, disabled }) => ({
	position: 'absolute',
	top: '2px',
	right: language == 'ar' ? 'unset' : '5px',
	left: language == 'ar' ? '5px' : 'unset',
	cursor: disabled ? 'default' : 'pointer',

	'& svg path': {
		fill: '#B7BCC6',
	},
}));

export const DocumentIcon = styled(Document)<DocumentIconProps>(({ isdisabled }) => ({
	'& path': {
		fill: isdisabled ? '#B7BCC6' : '#4786FF',
	},
}));

interface MicrophoneIconProps extends SVGProps<SVGSVGElement> {
	isdisabled?: boolean;
}

export const MicrophoneIcon = styled(Microphone)<MicrophoneIconProps>(({ isdisabled }) => ({
	'& path': {
		fill: isdisabled ? '#B7BCC6' : '#4786FF',
	},
}));
